// extracted by mini-css-extract-plugin
module.exports = {"pp_tbl_link":"style_pp_tbl_link__29tAL"};